export const locale = {
  lang: 'en',
  data: {
    'WAITING': 'Waiting for approval',
    'APPROVED': 'Approved',
    'REFUSED': 'Refused'
  }
};
